import { DefaultState } from 'store/types';

export const GET_SPLIT_FORM_DATA_REQUEST = 'GET_SPLIT_FORM_DATA_REQUEST';
export const GET_SPLIT_FORM_DATA_SUCCESS = 'GET_SPLIT_FORM_DATA_SUCCESS';
export const GET_SPLIT_FORM_DATA_FAILURE = 'GET_SPLIT_FORM_DATA_FAILURE';

export interface SplitRequestFormData {
  fromDate: string;
  toDate: string;
}

export type GetSplitFormDataState = DefaultState & {
  contents?: SplitRequestFormData;
};

interface GetSplitFormDataRequest {
  type: typeof GET_SPLIT_FORM_DATA_REQUEST;
};

interface GetSplitFormDataSuccess {
  type: typeof GET_SPLIT_FORM_DATA_SUCCESS,
  contents: SplitRequestFormData;
}

interface GetSplitFormDataFailure {
  type: typeof GET_SPLIT_FORM_DATA_FAILURE;
}

export type GetSplitFormDataActionTypes = GetSplitFormDataRequest | GetSplitFormDataSuccess | GetSplitFormDataFailure;
